<template>
    <div style="display: inline-block;text-indent:0;">
        <input :id="buttonId" type="file" :accept="acceptType" @input="changeAction" style="display: none;" />
        <Button :icon="buttonIcon" :class="buttonClass" :size="buttonSize" :type="buttonType" @click="triggerFileSelecter"> {{ buttonName | t }} </Button>
    </div>
</template>
<script>
export default {
    props: {
        //文件选择器change事件
        changeAction: {
            type: Function
        },
        //按钮的名称
        buttonName: {
            type: String
        },
        //按钮的ID
        buttonId: {
            type: String
        },
        //按钮的样式
        buttonType: {
            type: String,
            default: "primary"
        },
        //允许文件类型
        acceptType: {
            type: String,
            default: ".xlsx"
        },
        //按钮的icon
        buttonIcon: {
            type: String,
            default: "ios-cloud-upload-outline"
        },
        //按钮的尺寸
        buttonSize: {
            type: String,
            default: "default"
        },
        // 按钮的样式
        buttonClass: {
            type: String,
            default: ""
        }
    },
    methods: {
        triggerFileSelecter() {
            document.querySelector("#" + this.buttonId).click();
        },
        clearValue() {
            document.querySelector("#" + this.buttonId).value = "";
        }
    }
}
</script>
<style lang="less" scoped>

</style>


// WEBPACK FOOTER //
// src/components/upload_file.vue